import { EFinancingProgram } from '@if/core/types'
import { EMerchantProperties } from '@src/data/types/Constants'
import { Merchant } from '@src/data/types/Merchant'
import { MerchantFinancingProgramConfig } from '@src/data/types/MerchantFinancingProgramConfig'
import { useEffect } from 'react'
import { FieldValues, UseFormReturn } from 'react-hook-form'

export function useMerchantFormSync<T extends FieldValues>(
  form: UseFormReturn<T>,
  merchant: Merchant,
  merchantFinancingProgramConfigs: Partial<Record<EFinancingProgram, MerchantFinancingProgramConfig>>,
  merchantDefaultProperties: Record<EMerchantProperties, boolean>,
): void {
  const { reset } = form
  useEffect(() => {
    reset(
      {
        tags: merchant.tags ?? [],
        territoryId: merchant.territoryId,
        reportGenerationFrequency: merchant.reportGenerationFrequency,
        reportRecipientsEmailList: merchant.reportRecipientsEmailList,
        planPromoRules: merchant.planPromoRules,
        financingProgramConfigs: merchantFinancingProgramConfigs,
        bannerMerchantFeeRate: merchant.bannerMerchantFeeRate || undefined,
        flashPlanRateRebate: merchant.flashPlanRateRebate,
        lenderAdminFee: merchant.lenderAdminFee,
        ...merchantDefaultProperties,
      } as unknown as T,
      { keepDirtyValues: true },
    )
  }, [merchant, merchantFinancingProgramConfigs, merchantDefaultProperties, reset])
}
